<template>
  <CardFrame>
    <CardImage :image="image" :imageSize="'full'"></CardImage>
    <CardDownloadLink :link="data.buttons[0].asset.downloadUrl">
      Download {{ fileType }}
    </CardDownloadLink>
  </CardFrame>
</template>

<script>
import CardDownloadLink from "../../Atoms/Cards/CardDownloadLink.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import CardImage from "../../Atoms/Cards/CardImage.vue";

import { getFileType } from "../../../compostables/useHelpers";

export default {
  components: {
    CardDownloadLink,
    CardFrame,
    CardImage,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const image = props.data.hasOwnProperty("image")
      ? props.data.image
      : props.data.icon;

    const fileType = getFileType(image.fileType).toLowerCase();

    return {
      fileType,
      image,
    };
  },
};
</script>
